<script>
  export let title, poster, year;
</script>

<div class="col">
  <div class="card" style="width: 18rem;">
    <img src={poster} alt={title} class="card-img-top" />
    <div class="card-body">
      <h5 class="card-title">{title} {year}</h5>
      <!--
      {#if 2020 - year < 5}
        <i>🦄</i>
      {/if}
      -->
    </div>
  </div>
</div>

<style>
  .card {
    height: 100%;
  }
  .col {
    margin-bottom: 1em;
  }
  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
</style>
